import { createStore } from 'vuex'

export default createStore({

  state: {
    baseUrl: 'https://zeusis-cloud-api.daito.co.jp/v1/', // AWS API
    memberStatusUrl: 'status/', // 会員ステータス取得
    storeId: '',
    lineId: '',
    line_platform: {
      url1: 'https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=', // [固定]ユーザーに認証と認可URL
      url2: '&redirect_uri=',
      redirect_uri: 'https://member.daito.co.jp/screenBranch/', // LINE Developersコンソールに登録したコールバックURL
      url3: '&state=',
      url4: '&scope=profile',
    },
  },
  mutations: {
    setStoreId (state, value) {
      state.storeId = value
    },
    setLineId (state, value) {
      state.lineId = value
    },
  },
  actions: {
  },
  modules: {
  }
})
